import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch page Description list data
export const getPageDescriptionList = createAsyncThunk(
  "pageDescriptionList/getPageDescriptionList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/page/get_all_data`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const pageDescriptionSlice = createSlice({
  name: "pageDescriptionList",
  initialState: {
    loading: false,
    pageDescriptionData: null,
    error: null,
  },
  reducers: {
    clearPageData: (state) => {
      state.pageDescriptionData = null; // Clear old data
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPageDescriptionList.pending, (state) => {
        state.loading = true;
        state.pageDescriptionData = null; // Reset to prevent showing old data
        state.error = null;
      })
      .addCase(getPageDescriptionList.fulfilled, (state, action) => {
        state.loading = false;
        state.pageDescriptionData = action.payload;
      })
      .addCase(getPageDescriptionList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPageData } = pageDescriptionSlice.actions;
export default pageDescriptionSlice.reducer;
